import { Checks, Copy, Download, Phone, UserPlus, X } from "@phosphor-icons/react";
import React, { useEffect, useMemo, useState } from 'react';
import "./../../../Styles/ManageGuestsModal.css";
import ViewGuests from "./ViewGuests";
import ViewGuestsFields from "./ViewGuestsFields";
import axiosInstance from "../../../api/axiosInstance";
import PageLoader from "../../loader/PageLoader";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { toast, Toaster } from "react-hot-toast";
import SaveChangesModal from "./SaveChangesModal";
import MainSaveModal from "./MainSaveModal";
import { buildGuestPayload } from "../../../api/guestPayload";
import { collectOtherRoomContacts } from "../../../api/guestContacts";
import { toHotelISO, formatHotel } from "../../../api/hotelTime";
// Extend dayjs with the plugins
dayjs.extend(utc);
dayjs.extend(timezone);

export default function ManageGuestsModal(props) {

    const hotelId = localStorage.getItem("hotelId");

    // const [roomsData,setRoomsData] = useState(props?.roomsData || []);
    // console.log("Rooms Data : ",roomsData)

    // Loading
    // const [isLoading,setIsLoading] = useState(false);

    // Form Open
    const [isFormOpen,setIsFormOpen] = useState(false);

    const [activeUser,setActiveUser] = useState(-1);
    const [imageLoad,setImageLoad] = useState(false);
    const [roomNumber,setRoomNumber] = useState("");
    const [codeCopied,setCodeCopied] = useState(false);

    const copyBookingCode = ()=>{
        const code = props?.bookingData?.booking_code;
        if(!code){
            return;
        }
        navigator.clipboard.writeText(code).then(()=>{
            setCodeCopied(true);
            setTimeout(()=>setCodeCopied(false), 2000);
        }).catch((error)=>{
            console.log(error);
            toast.error("Could not copy the booking code");
        });
    }

    // For Saving Changes
    const [savedChanges,setSavedChanges] = useState(false);
    const [guestFormDirty,setGuestFormDirty] = useState(false);
    const [openSaveModal, setOpenSaveModal] = useState(false);
    // For the 
    const [mainSaveModal,setMainSaveModal] = useState(false);

    // General Form Data 
    const [generalFormData, setGeneralFormData] = useState({
        name: props?.bookingData?.name || "",
        contact: props?.bookingData?.contact?.toString().slice(2) || "", // Remove first 2 characters
        checkInDate: props?.bookingData?.checkInDate || "",
        checkOutDate: props?.bookingData?.checkOutDate || "",
        otaId: props?.bookingData?.ota_id || "",
        countryCode: props?.bookingData?.contact?.toString().slice(0, 2) || "91", // Extract first 2 characters as country code
    });

    // Error Handling for Form
    const [errors,setErrors] = useState({}); 
    const validateField = (field, value)=>{
        try{
          const newErrors = { ...errors };
          switch (field) {
            case "checkInDate":
              if (value.trim() === "") {
                newErrors.checkInDate = "check-in-date is required";
              } 
              else{
                newErrors.checkInDate = "";
              }      
              break;
            case "checkOutDate":
              if (value.trim()==="") {
                newErrors.checkOutDate = "check-out-date is required";
              }
              else{
                newErrors.checkOutDate = "";
              }
              break;
    
            case "name":
                if (value.trim() === "") {
                    newErrors.name = "booking-name is required";
                } 
                else{
                    newErrors.name = "";
                }      
                break;
    
            case "otaId":
                if (value.trim() === "") {
                    newErrors.otaId = "ota-id is required";
                } 
                else{
                    newErrors.otaId = "";
                }      
                break;
            
            case "contact":
                if (value.trim() === "") {
                    newErrors.contact = "contact is required";
                } 
                else{
                    newErrors.contact = "";
                }      
                break;
     
          }
        setErrors(newErrors);
    
        }catch(error){
          console.log(error);
        }
    }

    const validateForm = ()=>{
        try{
            const newErrors = {};
            if(!generalFormData.name.trim()){
                newErrors.name = "Booking Name is required"; 
            }  
            if (!generalFormData.contact.trim() || /^\s*$/.test(generalFormData.contact) || !/^\d+$/.test(generalFormData.contact)) {
                newErrors.contact = "Contact is required";
            }
            if(!generalFormData.checkInDate.trim()){
                newErrors.checkInDate = "Check In Date is required"; 
            }
            if(!generalFormData.checkOutDate.trim()){
                newErrors.checkOutDate = "Check Out Date is required"; 
            }
            if(!generalFormData.otaId.trim()){
                newErrors.otaId = "OTA ID is required"; 
            }
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        }catch(error){
            console.log(error);
        }
    }
    
    // const validateRoomNumber = (field, value)=>{
    //     try{
    //         const newErrors = { ...errors };
    //             switch (field) {
    //                 case "roomNumber":
    //                     if (value.trim() === "") {
    //                         newErrors.roomNumber = "room-number is required";
    //                     } 
    //                     else{
    //                         newErrors.roomNumber = "";
    //                     }      
    //                 break;
    //             }
    //         setErrors(newErrors);
    //     }catch(error){
    //         console.log(error);
    //     }
    // }
    // const validateFormRoomNumber = ()=>{
    //     try{
    //         const newErrors = {};
    //         if (/^\s*$/.test(roomNumber) || !/^\d+$/.test(roomNumber)) {
    //             newErrors.roomNumber = "room number must be integer";
    //         }
    //         setErrors(newErrors);
    //         return Object.keys(newErrors).length === 0;

    //     }catch(error){
    //         console.log(error);
    //     }
    // }
    // console.log("Errors : ",errors);


    const [roomNumberData,setRoomNumberData] = useState([]);
    const [savedRoom,setSavedRoom] = useState("");

    useEffect(()=>{
        const assignRoomNumber = ()=>{
            try{

                const roomData = props.bookedRoomsData.map((room) => ({
                    room_number: "",  // Initially empty room number
                    roomId: room.id,  // Assuming 'id' is the property for the room ID
                  }));
                  
                setRoomNumberData(roomData);  // Set the room data to state


            }catch(error){
                console.log(error);
            }
        };
        assignRoomNumber();
    },[]);



    useEffect(()=>{
        if(!props.bookingData || !props.bookedRoomsData){
            props.setManageGuestModal(false);
        }
    },[]);

 
    // Close Modal
    const handleClose = ()=> {
        try{

            if(savedChanges || guestFormDirty || String(savedRoom ?? "") !== String(roomNumber ?? "")){

                console.log("Save The Changes First");
                setMainSaveModal(true);
                return;
            }


            props.setManageGuestModal(false);
            setRoomId("");
            props.setBookedRoomsData(null);
            props.setBookingData(null);

            // props.setRoomsData([]);

        }catch(error){
            console.log(error);
        }
    }


    // Guest Form Data
    const [guestForm, setGuestForm] = useState({
        name:  "",
        contact:   "",
        verification_id: "",
        countryCode: "91",
        manual_verification : false,
        email : "",
        address : "",
        is_minor : false,
    });
    

    // For Making Room Active
    const [roomId,setRoomId] = useState("");
    const [guests,setGuests] = useState([]);
    const [roomChangeLoad,setRoomChangeLoad] = useState(false);
    const [downloading,setDownloading] = useState(false);
    const [roomGuestsData,setRoomGuestsData] = useState([]);

    // Contacts already taken by the booking's other rooms. A contact belongs to one
    // guest per booking, so the guest form checks new numbers against these too.
    const otherRoomContacts = useMemo(
        () => collectOtherRoomContacts(props.bookedRoomsData, roomId),
        [props.bookedRoomsData, roomId],
    );

   


    // Get The Web Check In Data for Guests 
    const getWebCheckInGuests = async(id)=>{
        try{
            const response = await axiosInstance.get(`/api/v1/hotels/${hotelId}/bookings/${props.bookingData.bookingId}/booked-rooms/${id}/guest-requests/web-checkin`);
            console.log("Response Web Check In : ",response.data);
            let guests = response?.data?.guest_details || [];
            return guests;
        }catch(error){
            console.log(error);
            let guests = [];
            return guests;   
        }
    }


    useEffect(()=>{
        const preSelectRoom = async()=>{
            try{
                setRoomId(props.bookedRoomsData[0].id);
                setRoomChangeLoad(true);
                setImageLoad(false);
                setActiveUser(-1)
                setIsFormOpen(false)
                await activeRoomId(props.bookedRoomsData[0].id);
            }catch(error){
                console.log(error);
            }
        }
        preSelectRoom();

    },[]);

    useEffect(()=>{

        if(JSON.stringify(roomGuestsData)===JSON.stringify(guests)){
            console.log("Room Guests : ",roomGuestsData);
            console.log("Guetss : ",guests);
            setSavedChanges(false);
        }
    },[roomGuestsData, guests])
     

    // const makePreSelectionRoom
    const activeRoomId = async(id)=>{
        try{
 
            if(savedChanges || guestFormDirty || String(savedRoom ?? "") !== String(roomNumber ?? "")){

                console.log("Save The Changes First");
                setOpenSaveModal(true);
                return;
            }

            setRoomId(id);
            setRoomChangeLoad(true);
            setImageLoad(false);

            // Close the guest panel on a room switch: the form belongs to the
            // room we are leaving, so leaving it open just shows a blank one.
            setActiveUser(-1)
            setIsFormOpen(false)

            setGuestForm({
                name:  "",
                contact:   "",
                verification_id: "",
                countryCode: "91",
                manual_verification : false,
                email : "",
                address : "",
                is_minor : false
            })

            const getGuestsRoom = props.bookedRoomsData.find((room)=>room.id===id);

            //  Fetch the Booked Room By ID For Latest Guest Updates
            const response = await axiosInstance.get(`/api/v1/hotels/${hotelId}/bookings/${props?.bookingData?.bookingId}/booked-rooms/${getGuestsRoom.id}`);

            // Always sync roomNumber + savedRoom from the server (empty when the room
            // has no number yet) — leaving either stale makes the unsaved-changes
            // check report a phantom edit on close / room switch
            const fetchedRoomNumber = response?.data?.room_number ? response.data.room_number.toString() : "";
            setRoomNumber(fetchedRoomNumber);
            setSavedRoom(fetchedRoomNumber);
            setRoomNumberData((prevData) =>
                prevData.map((room) =>
                    room.roomId === id ? { ...room, room_number: fetchedRoomNumber } : room
                )
            );
          
            const roomGuests = response?.data?.guests || [];
            setRoomGuestsData(roomGuests);

            setSavedChanges(false);

            // The web check-in list is only ever used to seed an empty room, so
            // skip that request entirely once the room already has guests.
            if(roomGuests.length > 0 || response?.data?.is_checkin_completed){
                setGuests(roomGuests);
                return;
            }

            const guestsData = await getWebCheckInGuests(id);
            const datawebCheckIn = guestsData
                .filter((guest)=>guest.hotel_approved==="HOTEL_APPROVED")
                .map((guest)=>({
                    name : guest?.name || "",
                    contact : guest?.contact || "",
                    verification_id : guest?.verification_id || "",
                    is_minor : guest?.is_minor || false
                }));

            setGuests(datawebCheckIn);
        }catch(error){
            console.log(error);
            
            toast.error(error?.response?.data?.message || "Internal Server Error");
        }finally{
            setRoomChangeLoad(false);
        }
    }
    


    const addNewUser = ()=>{
        try{
            setIsFormOpen(true);

            setActiveUser(-1);
        }catch(error){
            console.log(error);
        }
    }

    // Make user Active 
    const makeUserActive = (user)=>{
        try{
            setIsFormOpen(true);
            setActiveUser(user)
        }catch(error){
            console.log(error);
        }
    }

    

    // Handle Change 
    const handleChange = (event)=>{
        try{
            const name = event.target.name;
            const value = event.target.value;
            validateField(name,value);
            setGeneralFormData(values => ({...values, [name]: value}));
        }catch(error){
            console.log(error);
        }
    }

 

    // Update roomNumber when roomId changes
    useEffect(() => {
        if (roomId) {
            const selectedRoom = roomNumberData.find(room => room.roomId === roomId);
            if (selectedRoom) {
                setRoomNumber(selectedRoom.room_number); // Set room number from the selected room
            }
        }
    }, [roomId, roomNumberData]);
 

    // A room number is the check-in: reassigning it needs the open requests, the
    // PMS and the guest's welcome details moved with it, none of which this modal
    // does. Assign once here; moves go through a Room Change request.
    const isRoomNumberLocked = Boolean(savedRoom);

    // Update room number in roomNumberData when user types into the input
    const handleRoomNumberChange = (event) => {
        const newRoomNumber = event.target.value;       
        setRoomNumber(newRoomNumber);

 
        // Update the room number in roomNumberData based on roomId
        setRoomNumberData((prevData) => 
        prevData.map((room) =>
            room.roomId === roomId ? { ...room, room_number: newRoomNumber } : room
        )
        );
    };
 


    // Update Manage Guests
    const updateManageGuests = async()=>{
        try{
            if(!validateForm()){
                // console.log("Please Validate Form");
                return;
            }
            if(guests.length > 0 && guests.every((guest)=>guest.is_minor)){
                toast.error("A room must have at least one adult guest");
                return;
            }
            setRoomChangeLoad(true);


            // console.log("General Data : ",generalFormData);
            // console.log("Guests Data : ",guests);
            // console.log("Room Number Data : ",roomNumberData);

            // Bookings Update
            let finalContactBooking = parseInt(generalFormData.countryCode + generalFormData.contact);
            let checkBookingData = {
                checkin_date : props?.bookingData?.checkInDate,
                checkout_date : props?.bookingData?.checkOutDate,
                ota_id : props?.bookingData?.ota_id,
                name : props?.bookingData?.name,
                contact :  props?.bookingData?.contact,
                booking_email : props?.bookingData?.email,
                guest_email : props?.bookingData?.email,
                booking_type : "",
                rooms : props?.bookingData?.rooms,
                number_of_people : props?.bookingData?.number_of_people
            }

            let formBookingData = {
                checkin_date : generalFormData.checkInDate,
                checkout_date : generalFormData.checkOutDate,
                ota_id : generalFormData.otaId,
                name : generalFormData.name,
                contact : finalContactBooking,
                booking_email : props?.bookingData?.email,
                guest_email : props?.bookingData?.email,
                booking_type : "",
                rooms :  props?.bookingData?.rooms,
                number_of_people : props?.bookingData?.number_of_people
            }

            let data1 = JSON.stringify(checkBookingData);
            let data2 = JSON.stringify(formBookingData);

            // console.log("data 1 : ",checkBookingData)
            // console.log("data 2 : ",formBookingData)
            if(data1===data2){
                console.log("No Change in booking")
            
            }
            else{
                console.log("Change in booking")
                const checkInDate = toHotelISO(generalFormData.checkInDate);
                const checkOutDate = toHotelISO(generalFormData.checkOutDate);
    
                try{
    
    
                    const finalContact = parseInt(generalFormData.countryCode + generalFormData.contact);
                    // console.log("Guest Name : ",generalFormData.name);
    
                    const bookingData = {
                        checkin_date : checkInDate,
                        checkout_date : checkOutDate,
                        ota_id : generalFormData.otaId,
                        name : generalFormData.name,
                        contact : finalContact,
                        booking_email : props?.bookingData?.email,
                        guest_email : props?.bookingData?.email,
                        booking_type : "",
                        rooms : props?.bookingData?.rooms,
                        number_of_people : props?.bookingData?.number_of_people
                    };
                    const response = await axiosInstance.put(`/api/v1/hotels/${hotelId}/bookings/${props?.bookingData?.bookingId}`,bookingData);
    
                    // console.log("Response : ",response.data);
                    toast.success("Booking Updated Successfully");
    
                }catch(error){
                    console.log(error);
                    toast.error("Error Occured While Updating Booking and Rooms are not Updated : ",error?.response?.data?.message || "Internal Server Error");
                     
                }
            }


            // Booked Room Update

            try{
                // The booked-room payload already carries user_id for every guest
                // that is linked to an Alfred account, and the backend links the
                // rest by contact — no need to pull down the whole user table.
                const updatedGuests = guests.map(guest => buildGuestPayload(guest));

                const matchingRoom = roomNumberData.find(roomData => roomData.roomId === roomId);
                // console.log("Matching Room : ",matchingRoom);
                let roomNum = matchingRoom.room_number;
                // Check if roomNum is an empty string, set it to null if true
                if (roomNum === "") {
                    roomNum = null;
                }  
                // Check if roomNum is a string that contains only numeric digits
                if (!/^\d+$/.test(roomNum) && roomNum !== null) {
                    toast.error("Room number should only contain digits.");
                    return
                }
            
                let roomNumInt = roomNum===null ? null : parseInt(roomNum, 10);

                // console.log("Room number : ",roomNumInt);

 
                let formattedCheckinDate = formatHotel(generalFormData.checkInDate, "YYYY-MM-DDTHH:mm:ssZ");
                let formattedCheckoutDate = formatHotel(generalFormData.checkOutDate, "YYYY-MM-DDTHH:mm:ssZ");
                
                const bookedRoomData = {
                    room_number: roomNumInt,
                    number_of_guests : guests.length,
                    checkin_date : formattedCheckinDate,
                    checkout_date : formattedCheckoutDate,
                    guest_details : updatedGuests
                }

                try{
                    const response2 = await axiosInstance.put(`/api/v1/hotels/${hotelId}/bookings/${props?.bookingData?.bookingId}/booked-rooms/${roomId}`,bookedRoomData);
                    toast.success("Room Update Completed Successfully");

                    // Re-seed from the response instead of re-fetching: it carries
                    // the saved guests plus the user_id the backend linked them to.
                    const savedGuests = response2?.data?.guests || [];
                    setGuests(savedGuests);
                    setRoomGuestsData(savedGuests);

                    // Now He can move to next room
                    setSavedRoom(roomNumber)
                    setSavedChanges(false);
                }catch(error){
                    console.log(error);   
                    toast.error(`Error Occurred While Updating Rooms: ${error?.response?.data?.message || "Some Error Occurred"}`);
                }

            }catch(error){
                toast.error(`Error Occurred While Updating Rooms: ${error?.response?.data?.message || "Some Error Occurred"}`);
                console.log(error);               
            }


           

        }catch(error){
            console.log(error);
            toast.error(`Error Occurred While Updating Rooms: ${error?.response?.data?.message || "Some Error Occurred"}`);
        }
        finally{
            setRoomChangeLoad(false);
        }
    }

    // console.log("Errors  : ",errors);

    // Handle Pdf download
    // const handlePdf = async()=>{
    //     try{
    //         const response = await axiosInstance.get(`/api/v1/hotels/${hotelId}/bookings/${props?.bookingData?.bookingId}/download-pdf`)
    //     }catch(error){
    //         console.log(error)
    //     }

    // }
    const handleDownload = async () => {
        try {
            setDownloading(true);

            const response = await axiosInstance.get(
                `/api/v1/hotels/${hotelId}/bookings/${props?.bookingData?.bookingId}/download-pdf`,
                {
                    responseType: 'blob', // 👈 Tells axios to treat response as binary
                }
            );

            // Create a blob URL from the response
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary anchor element
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`booking-details-${generalFormData?.otaId || ""}.pdf`); // File name
            document.body.appendChild(link);
            link.click(); // Trigger the download
            link.remove(); // Cleanup
            window.URL.revokeObjectURL(url); // Free memory
        } catch (error) {
            toast.error("Failed to download pdf please re-download")
            console.error('Download failed:', error);   
        }
        finally{
            setDownloading(false);
        }
    };


  return (
    <> 
        <div
            className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001] overflow-auto"
            onMouseDown={(e) => {
                // Close only when the click starts on the backdrop itself
                if (e.target === e.currentTarget) handleClose();
            }}
        >


            {(roomChangeLoad || downloading) && <PageLoader/>}

            <div className="manageGuestsModal popup-content bg-white p-6 rounded-xl shadow-2xl text-sm flex flex-col gap-3 w-[80%] md:w-[70%] lg:w-[55%] top-10 max-h-[98vh] overflow-y-auto">

                {/* Header of Mange Modal */}
                <div className="flex items-center justify-between border-b pb-3">
                    <div>
                        <h2 className="text-xl font-semibold">Manage Guests</h2>
                        <p className="text-xs text-gray-400 mt-0.5">
                            Edit booking details, assign rooms and manage guests
                        </p>
                    </div>
                    <button
                        onClick={()=>handleClose()}
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                {/* Booking code and stay dates */}
                <div className="grid grid-cols-3 gap-4">
                    <div>
                        <p className="text-[#8C9199] mb-2">Booking Code</p>
                        <div className="flex items-center gap-2 py-1">
                            <span
                                className="font-mono font-semibold tracking-wider text-[#262B33] bg-[#EEF0FB] border-[1.5px] border-[#BFC4CC] rounded-md px-2.5 py-1 truncate"
                                title={props?.bookingData?.booking_code || "NA"}
                            >
                                {props?.bookingData?.booking_code || "NA"}
                            </span>
                            {props?.bookingData?.booking_code &&
                                <button
                                    type="button"
                                    className="text-[#8C9199] hover:text-[#0B22B2] shrink-0"
                                    title="Copy booking code"
                                    onClick={()=>copyBookingCode()}
                                >
                                    {codeCopied ? <Checks size={16} /> : <Copy size={16} />}
                                </button>
                            }
                        </div>
                    </div>
                    <div>
                        <p className="text-[#8C9199] mb-2">Check-in Date</p>
                        <input
                            type="datetime-local"
                            className="w-full p-2 rounded-md border-[1.5px]"
                            name="checkInDate"
                            value = {generalFormData?.checkInDate || "" }
                            onChange={(e)=>handleChange(e)}
                        />
                        {errors.checkInDate && <span className='text-xs text-[#FF7378]'>{errors.checkInDate}</span>}
                    </div>
                    <div>
                        <p className="text-[#8C9199] mb-2">Check-out Date</p>
                        <input
                            type="datetime-local"
                            className="w-full p-2 rounded-md border-[1.5px]"
                            name="checkOutDate"
                            value = {generalFormData?.checkOutDate || "" }
                            onChange={(e)=>handleChange(e)}
                        />
                        {errors.checkOutDate && <span className='text-xs text-[#FF7378]'>{errors.checkOutDate}</span>}
                    </div>
                </div>

                {/* Booker details — same 3 column grid so both rows line up */}
                <div className="grid grid-cols-3 gap-4">
                    {/* Name */}
                    <div>
                        <p className="text-[#8C9199] mb-2">Booking Name</p>
                        <input
                            type="text"
                            className="w-full p-2 rounded-md border-[1.5px]"
                            name="name"
                            value = {generalFormData?.name || ""}
                            onChange={(e)=>handleChange(e)}
                        />
                        {errors.name && <span className='text-xs text-[#FF7378]'>{errors.name}</span>}
                    </div>
                    {/* OTA ID */}
                    <div>
                        <p className="text-[#8C9199] mb-2">OTA ID</p>
                        <input
                            type="text"
                            className="w-full p-2 rounded-md border-[1.5px]"
                            name="otaId"
                            value = {generalFormData?.otaId || ""}
                            onChange={(e)=>handleChange(e)}
                        />
                        {errors.otaId && <span className='text-xs text-[#FF7378]'>{errors.otaId}</span>}
                    </div>
                    {/* Contact */}
                    <div>
                        <p className="text-[#8C9199] mb-2">Contact</p>
                        <div className="border-[1.5px] rounded-md flex w-full overflow-hidden">
                            <select
                                name="countryCode"
                                className="p-2 border-r-[1.5px] outline-none bg-transparent"
                                value = {generalFormData?.countryCode || ""}
                                onChange={(e)=>handleChange(e)}
                                >

                                <option value="91">+91</option>
                                <option value="44">+44</option>
                                <option value="86">+86</option>
                                <option value="81">+81</option>
                            </select>
                            <div className="rounded-md w-full flex items-center gap-2 px-2 min-w-0">
                                <Phone size={19} className="shrink-0" />
                                <input
                                    type="text"
                                    placeholder="Enter contact number"
                                    className="w-full min-w-0 p-2 pl-0 outline-none"
                                    name="contact"
                                    maxLength={10}
                                    value = {generalFormData?.contact || ""}
                                    onChange={(e)=>handleChange(e)}
                                />
                            </div>
                        </div>
                        {errors.contact && <span className='text-xs text-[#FF7378]'>{errors.contact}</span>}
                    </div>
                </div>

                {/* Room Buttons */}
                <div className="my-2 virtualRooms flex gap-2 max-w-full min-h-10 overflow-x-auto">
                    {/* Handling Rooms Data */}
                    {
                        props.bookedRoomsData.map((room,index)=>{
                            return <button key={room.id} className={` px-4 py-2 rounded-full flex-shrink-0 flex items-center gap-2 font-medium transition-colors
                                ${room.id===roomId ? "bg-[#ff7378] text-white shadow-md" : "bg-gray-100 hover:bg-gray-200 text-gray-600"}
                            `}
                                onClick={()=>activeRoomId(room.id)}

                                >
                                <span>Room {index+1}</span>

                            </button>
                        })
                    }                
                </div>

                {/* Room Number Assignation */}
                {roomId==="" ? 
                    <span></span>
                    :
                    <div className="my-2">
                        {/* Rooms Data */}
                        <h4>
                            Room Number 
                        </h4>
                        <input
                            type="text"
                            placeholder="Enter Room Number"
                            className={`w-full my-1 p-2 border border-[#BFC4CC] rounded-md ${isRoomNumberLocked ? "bg-[#F5F6FA] text-[#98A0AE] cursor-not-allowed" : ""}`}
                            onChange={handleRoomNumberChange}
                            value={roomNumber || ""}
                            name="roomNumber"
                            disabled={isRoomNumberLocked}
                        />
                        
                        {/* <select name="" id="">
                            <option value="">Select Room</option>
                            {roomsData.map((room,index)=>{
                                return(
                                    <option value="">{room.number}</option>
                                )
                            })}
                        </select> */}
                        
                        {errors.roomNumber && <span className='text-xs text-[#FF7378]'>{errors.roomNumber}</span>}
                    </div>
                }
    
                {/* Guests Image and Input Fields */}
                <div className="flex gap-2 border-t border-[#BFC4CC]">

                    {/* Guests Data */}
                    <div className=' flex-[0.4] p-2 border-r border-[#BFC4CC]   overflow-hidden'>
                        <div className="viewGuests flex flex-col gap-2 h-[520px] overflow-y-auto relative p-2">
                            
                            {/* Add Guests Button */}
                            {!isFormOpen &&
                                <button className={`w-full p-3 bg-[#FF7378] text-white font-medium rounded-lg transition-colors hover:bg-[#f0575d] ${(roomId==="" ||imageLoad) ? "bg-[#FFF2F2] text-[#FF7378] cursor-not-allowed hover:bg-[#FFF2F2]" : ""} `}
                                onClick={()=>addNewUser()}
                                >
                                    + Add Guest
                                </button>
                            }

                            {guests.map((user,index)=>{
                                return <ViewGuests key={index} user={user} 
                                    activeUser = {activeUser}
                                    guestIndex={index} 
                                    setActiveUser = {setActiveUser}
                                    makeUserActive = {makeUserActive}
                                    roomId = {roomId}
                                    guests = {guests}
                                    setGuests = {setGuests}
                                    imageLoad = {imageLoad}
                                    setImageLoad = {setImageLoad}
                                    setSavedChanges = {setSavedChanges}
                                    isFormOpen = {isFormOpen}
                                    setIsFormOpen = {setIsFormOpen}
                                />
                            })}
                        </div>
                    </div>
                    
                    {/* Guest Input Field */}
                    <div className='flex-[0.6]'>
                        {!isFormOpen &&
                            <div className="h-[520px] flex flex-col items-center justify-center gap-2 text-center px-6 text-[#8C9199]">
                                <UserPlus size={32} />
                                <p className="font-medium text-[#262B33]">No guest selected</p>
                                <p className="text-xs">
                                    Pick a guest on the left to edit them, or use “+ Add Guest” to add a new one.
                                </p>
                            </div>
                        }
                        <ViewGuestsFields
                            guestData = {guests[activeUser]}       
                            roomId = {roomId}
                            guests = {guests}
                            setGuests = {setGuests}
                            setActiveUser = {setActiveUser}
                            activeUser = {activeUser}
                            guestForm = {guestForm}
                            setGuestForm = {setGuestForm}
                            imageLoad = {imageLoad}
                            setImageLoad = {setImageLoad}
                            setSavedChanges = {setSavedChanges}
                            setGuestFormDirty = {setGuestFormDirty}
                            isFormOpen = {isFormOpen}
                            setIsFormOpen = {setIsFormOpen}
                            otherRoomContacts = {otherRoomContacts}
                        />
                    </div>
                
                </div>
                
                {/* Submit Button For Room */}
                <div className='flex flex-col gap-4 mt-2 text-center'>
                    <button className={`w-full bg-[#FF7378] text-white font-semibold p-2.5 rounded-lg transition-colors hover:bg-[#f0575d] ${(imageLoad) ? "bg-[#FFF2F2] text-[#FF7378] cursor-not-allowed hover:bg-[#FFF2F2]" : ""}`}
                        onClick={()=>updateManageGuests()}
                    >
                        Update Room / Booking
                    </button>
              
                    <button  className={`w-full p-2 rounded-lg text-white text-center flex justify-center items-center gap-4 ${downloading ? "bg-[#8C9199] cursor-not-allowed" : "bg-[#0B22B2]"}`}
                   onClick={()=>handleDownload()}
                   disabled={downloading}
                   >
                        {downloading ? "Preparing…" : "Download PDF"}
                        <Download size={20} />
                    </button>

                </div>
    
            </div>
            <Toaster
                position="bottom-right"
                reverseOrder={false}
                transition="Bounce"
                style={{ marginBottom: "25%" }}
            />
        </div>

        {
            openSaveModal && <SaveChangesModal
                setOpenSaveModal = {setOpenSaveModal}
            />
        }
        {
            mainSaveModal && <MainSaveModal
                setMainSaveModal = {setMainSaveModal}
                manageGuestModal = {props.setManageGuestModal}
                setRoomId = {setRoomId}
                setBookedRoomsData = {props.setBookedRoomsData}
                setBookingData = {props.setBookingData}

            />
        }
    </>
  )
}
